import React from 'react';
import { SECTIONS } from '../data/sections';

export default function Breadcrumb({ page, currentSection, onDash, onRole }) {
  if (page === 'role') return null;

  return (
    <div className="breadcrumb">
      <a onClick={onRole}>Roles</a>
      <i className="ti ti-chevron-right" style={{ fontSize: 10 }} aria-hidden="true" />
      {page === 'section' && currentSection ? (
        <>
          <a onClick={onDash}>Dashboard</a>
          <i className="ti ti-chevron-right" style={{ fontSize: 10 }} aria-hidden="true" />
          <span>{currentSection} — {SECTIONS[currentSection]?.title}</span>
        </>
      ) : (
        <span>Dashboard</span>
      )}
    </div>
  );
}
